/**
 * Hora de sortida pactada amb l'hoste (portes v1, sprint 06 §4): `"HH:mm"` de Madrid, de 12:00 a
 * 20:00 cada 30 min; `null` = la de sempre, 12:00. La desa `PATCH /reservations/:id/agreed-checkout`
 * (`update-agreed-checkout.dto.ts`, mateixa franja) i allarga o escurça el codi de les portes.
 */

export const AGREED_CHECKOUT_MIN = '12:00';
export const AGREED_CHECKOUT_MAX = '20:00';
export const AGREED_CHECKOUT_STEP_MIN = 30;

/** Valor del `Select` per a «sense hora pactada» (un `SelectItem` no pot tenir el valor buit). */
export const AGREED_CHECKOUT_NONE = 'none';

export const AGREED_CHECKOUT_NONE_LABEL = 'Sense hora pactada (12:00)';

const toMinutes = (hhmm: string) => Number(hhmm.slice(0, 2)) * 60 + Number(hhmm.slice(3, 5));
const pad = (n: number) => String(n).padStart(2, '0');

/** 12:00, 12:30 … 20:00 (17 hores). */
export const AGREED_CHECKOUT_TIMES: readonly string[] = (() => {
  const out: string[] = [];
  for (let m = toMinutes(AGREED_CHECKOUT_MIN); m <= toMinutes(AGREED_CHECKOUT_MAX); m += AGREED_CHECKOUT_STEP_MIN) {
    out.push(`${pad(Math.floor(m / 60))}:${pad(m % 60)}`);
  }
  return out;
})();

/** Les opcions del `Select`: «sense hora pactada» i les hores; una hora desada fora de la llista també hi és. */
export function agreedCheckoutOptions(current?: string | null): Array<{ value: string; label: string }> {
  const times = [...AGREED_CHECKOUT_TIMES];
  if (current && !times.includes(current)) times.push(current);
  times.sort();
  return [
    { value: AGREED_CHECKOUT_NONE, label: AGREED_CHECKOUT_NONE_LABEL },
    ...times.map((time) => ({ value: time, label: time })),
  ];
}

/** Valor del `Select` a partir de la reserva. */
export function agreedCheckoutSelectValue(time?: string | null): string {
  return time ? time : AGREED_CHECKOUT_NONE;
}

/** Cos del `PATCH`, o `null` si el valor triat és el que la reserva ja té. */
export function agreedCheckoutChange(
  current: string | null | undefined,
  selected: string | null | undefined,
): { time: string | null } | null {
  const before = current || null;
  const after = !selected || selected === AGREED_CHECKOUT_NONE ? null : selected;
  return before === after ? null : { time: after };
}

/** «surt a les 14:00» per al popover; `null` si no n'hi ha cap de pactada. */
export function agreedCheckoutLabel(time?: string | null): string | null {
  return time ? `surt a les ${time}` : null;
}
